import React, { useState } from 'react';
import { Card, Column, Columns } from '@codeparva/ui-components-library';
import { UnitAvailabilityTypes } from '../..';
import { HorizontalAndVerticalCardConfig } from '../constants/horizontalAndVerticalCardConfig';
import {
  GenericCTAButtonComponentHelper,
  ViewRatesAmenitiesCTA,
} from './CTAButtonHelper';
import { addZeroesAndGetWebRate } from './rateHelper';
import { Text } from '../../../../../../components/textVariations';
import { GetAlertText, getAmenitiesList } from './AmenitiesHelper';
import { CPImage } from '../../../../../../components/imageWrapper/CPImage';

export const VerticalCardsComponent = ({
  data,
  UnitAvailabilityConfig,
  theme,
  onSetIndividualData,
  WhatWeOfferConfig,
  index,
  transformedGatsbyImageData,
  facilityIdDetails,
}: UnitAvailabilityTypes.TVerticalTypeData) => {
  const [viewCTAStatus, setViewCTAStatus] = useState(false);
  const {
    unitTypeRate: { Month },
    unitTypeCategory,
    tfw,
    unitdimensions,
    unitTypeName,
  } = data;
  const { reservation: { is_enabled = false } = {} } = tfw;
  const selectHeaderTextColor = () => {
    return 'white';
  };
  const selectClassNameForCardHeader = () => {
    return `cp-section-bg-${theme}`;
  };
  const { currencyCodes } = HorizontalAndVerticalCardConfig;
  if (data) {
    const {
      vacantUnitsCount: { total_count },
    } = data;
    const getDescription = () => {
      if (tfw && tfw.description && unitdimensions) {
        const { description } = tfw;
        const { width, depth } = unitdimensions;
        return description
          ? description
          : data.aliasName
          ? data.aliasName
          : `${width}' X ${depth}' ${unitTypeCategory}`;
      } else {
        return unitTypeName;
      }
    };

    return (
      <Card className="cardContainer">
        <div className="cardImg">
          <CPImage
            gatsbyImageData={transformedGatsbyImageData}
            className="tile-image thumbNailImage"
          />
        </div>
        <Card.Header
          className={`cardHeader pl-5 is-flex is-justify-content-flex-start is-align-items-center ${selectClassNameForCardHeader()}`}
        >
          <h4
            className={`cardHeaderTitle has-text-${
              theme === 'light' ? 'primary' : selectHeaderTextColor()
            }`}
          >
            {getDescription()}
          </h4>
        </Card.Header>

        <Card.Content
          className={
            data.amenitiesList.length !== 0
              ? 'cardContent'
              : 'cardContentNoAmenities'
          }
        >
          <div className="is-flex is-flex-direction-row is-justify-content-space-between alertTextSection">
            <Text className="is-flex is-align-items-center category alertTextSectionPara">
              <Text renderAs={'span'} className="alertTextspan">
                <GetAlertText
                  totalCount={total_count}
                  isReservationOrMoveInEnabled={is_enabled}
                />
              </Text>
            </Text>
          </div>
          <div className="pt-4 amenitiesSectionVertical">
            <div className="amenitiesListDivVertical">
              {WhatWeOfferConfig &&
                getAmenitiesList(data, WhatWeOfferConfig, viewCTAStatus)}
            </div>
          </div>
          {data.amenitiesList.length >
            HorizontalAndVerticalCardConfig.totalAmentiesCount && (
            <ViewRatesAmenitiesCTA
              index={index}
              viewCTAStatus={viewCTAStatus}
              setViewCTAStatus={setViewCTAStatus}
            />
          )}
          <Columns className="is-flex is-flex-direction-column priceColumns">
            <Column className="is-flex  is-justify-content-flex-start is-align-items-center priceColumnTwo">
              <Text className="price has-text-black is-size-3">
                {currencyCodes[data.currencyCode] || '$'}
                {addZeroesAndGetWebRate(tfw, Month)}
                {HorizontalAndVerticalCardConfig.perMonth}
              </Text>
            </Column>
          </Columns>
        </Card.Content>

        <Card.Footer
          className={`cardFooter is-flex is-justify-content-center is-align-items-center cp-section-bg-white`}
        >
          <GenericCTAButtonComponentHelper
            UnitAvailabilityConfig={UnitAvailabilityConfig}
            data={data}
            onSetIndividualData={onSetIndividualData}
            facilityIdDetails={facilityIdDetails}
          />
        </Card.Footer>
      </Card>
    );
  }
  return <></>;
};
